import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { useFavicon } from '@ecp/common/src/hooks/layout/FaviconHook.js';

import defaultTheme from '@ecp/common/src/style/theme/default';
import skypass from '@ecp/common/src/style/theme/skypass';
import welplus from '@ecp/common/src/style/theme/welplus';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import { themeState } from '@ecp/fo/src/recoil/theme/atom';

const SiteInformationProvider = () => {
  const setTheme = useSetRecoilState(themeState);

  const { fetch, getSystemInformationByKey, systemInformation } = useSiteInfo();
  useFavicon(systemInformation);

  useEffect(() => {
    const handleSiteInformation = async () => {
      if (!getSystemInformationByKey('siteName')) {
        const result = await fetch();

        setSiteDesc(result.siteDesc);
        setTitle(result);
        switch(result.theme) {
          case 'skypass': setTheme(skypass); break;
          case 'welplus': setTheme(welplus); break;
          default: setTheme(defaultTheme);
        }
      }
    };
    handleSiteInformation();
  }, [fetch, getSystemInformationByKey, setTheme]);

  function setSiteDesc(siteDesc) {
    if (siteDesc) {
      const htmlContent = document.querySelector('meta[name="description"]'); // <content> 태그 찾기
      htmlContent.setAttribute('content', siteDesc);
    }
  }

  function setTitle(result) {
    const htmlTitle = document.querySelector('title'); // <title> 태그 찾기

    htmlTitle.innerText =
      result && result.isMultimall ? result.siteName : result.siteName + ' - 건강함에 새로움을 더하다.'; // <title> 태그에 변수 title값을 넣음
  }
};

export default SiteInformationProvider;
